/* eslint-disable import/no-cycle */

import { DataService } from '../../../config/dataService/dataService';
import { getQueryString } from '../../../utility/utility';

// export const getUserApi = (data) => {
//   return DataService.get(`/user/list?search=${data?.search}`);
// };

export const getUserApi = (data) => {
  return DataService.get(`/user/list?${getQueryString(data)}`);
};
export const getUserExportApi = (data) => {
  return DataService.get(`/user/export-list?${getQueryString(data)}`);
};

export const getNextPageUserApi = (data) => {
  return DataService.get(`/user/list?${getQueryString(data)}`);
};

export const getRoleApi = () => {
  return DataService.get('/users-permissions/roles');
};

export const inActiveUserApi = (data) => {
  return DataService.post(`/status`, data);
};

export const updateURLsApi = (data) => {
  return DataService.put(`/update-url`, data);
};

export const updateUserApi = (id, data) => DataService.put(`/user/${id}`, data);

export const getUserDetailApi = (id) => DataService.get(`/user/${id}`);

export const switchRoleApi = (data) => {
  return DataService.post(`/switch-user-login`, data);
};

export const selectPaymentStatus = (values) => {
  return DataService.get(`/payment-gateway-onboarding-status?lang=${values}`);
};
export const addUserApi = (data) => {
  const userData = {
    email: data.email,
    firstName: data.firstName,
    lastName: data.lastName,
    password: data.password,
    phoneNumber: data.phoneNumber && `${data?.countryCode}-${data.phoneNumber?.slice(data?.countryCode.length)}`,
    role: data.role,
    username: data.email,
  };
  return DataService.post('/users', userData);
};
